export const IS_PROD_ENV = window.location.href.includes(
  "https://karsten.digital"
);

export const API_ENV = IS_PROD_ENV ? "PRD" : "HML";
